import { render, staticRenderFns } from "./loadingAnimation.vue?vue&type=template&id=35c8bc25&scoped=true&"
import script from "./loadingAnimation.vue?vue&type=script&lang=js&"
export * from "./loadingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./loadingAnimation.vue?vue&type=style&index=0&id=35c8bc25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8bc25",
  null
  
)

export default component.exports